// extracted by mini-css-extract-plugin
export default {"benefit":"BenefitsBlock_benefit__Flt25","benefit__icon":"BenefitsBlock_benefit__icon__5sCvT","benefit__descr":"BenefitsBlock_benefit__descr__BQV-l"};